<!-- Row 1: Full-width header -->
<div class="w-full p-0">
  <app-header-nav></app-header-nav>
</div>

<!-- Row 2: Two columns (75% / 25%) -->
<div class="w-full flex flex-col lg:flex-row h-screen">
  <!-- Left (75%) -->
  <div class="w-full lg:w-2/3 bg-gray-200 p-3">
    <app-visuals></app-visuals>
  </div>

  <!-- Right (25%) -->
  <div class="w-full lg:w-1/3 bg-gray-200 p-3 overflow-y-auto">
    <app-selections-accordion></app-selections-accordion>
  </div>
</div>

<!-- Row 3: Full-width footer -->
<!--
<div class="w-full p-3">
  <app-panel-options></app-panel-options>
</div>

-->
